export default "__VITE_ASSET__gpAKL$8k__"